<template lang="pug">
  .component.component-backoffice-note-form
    .row
      .columns.small-12
        label Valid from
          DatePicker(v-model="note.valid_from")
        label Valid to
          DatePicker(v-model="note.valid_to")
        label Description
          input(v-model="note.description", type="text")
        button.button(:disabled="!note.description", @click="noteCompleted") Create
</template>
<script type="text/babel">


  import DatePicker from "../structure/DatePicker";

  export default {
    name: "NoteForm",
    components: {DatePicker},
    data() {
      return {
        note: {
          description: null,
          valid_from: null,
          valid_to: null,
        }
      }
    },
    created() {
    },
    methods: {
      noteCompleted() {
        this.$emit('completed', this.note)
      }
    },
    computed: {},
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// NoteForm.vue?3ef6178b